import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
    // {name:'Bhavya Khailkhura',con:'Lawrence Livermore National Lab'},
    // {name:'Catherine Olsson',con:'OpenAI'},
    // {name:'Chaowei Xiao',con:'University of Michigan'},
    // {name:'David Evans',con:'University of Virginia'},
    // {name:'Dimitris Tsipras',con:'Massachusetts Institute of Technology'},
    // {name:'Earlence Fernandes',con:'University of Washington'},
    // {name:'Eric Wong',con:'Carnegie Mellon University'},
    // {name:'Fartash Faghri',con:'University of Toronto'},
    // {name:'Yuefeng Chen',con:'Alibaba Group'},
    // {name:'Florian Tramer',con:'Stanford University'},
    // {name:'Hadi Abdullah',con:'University of Florida'},
    // {name:'Hao Su',con:'UCSD'},
    // {name:'Jonathan Uesato',con:'DeepMind'},
    // {name:'Karl Ni',con:'In-Q-Tel'},
    // {name:'Kassem Fawaz',con:'University of Wisconsin-Madison'},
    // {name:'Kathrin Grosse',con:'CISPA'},
    // {name:'Hui Xue',con:'Alibaba Group'},
    // {name:'Zhao Li',con:'Alibaba Group'},
    // {name:'Krishna Gummadi',con:'MPI-SWS'},
    // {name:'Matthew Wicker',con:'University of Georgia'},
    // {name:'Mengyi Liu',con:'Alibaba Group'},
    // {name:'Nathan Mundhenk',con:'Lawrence Livermore National Lab'},
    // {name:'Nicholas Carlini',con:'Google Brain'},
    // {name:'Nicolas Papernot',con:'Google Brain and University of Toronto'},
    // {name:'Octavian Suciu',con:'University of Maryland'},
    // {name:'Pin-Yu Chen',con:'IBM'},
    // {name:'Pushmeet Kohli',con:'DeepMind'},
    // {name:'Shreya Shankar',con:'Stanford University'},
    // {name:'Suman Jana',con:'Columbia University'},
    // {name:'Tianyu Pang',con:'Tsinghua University'},
    // {name:'Varun Chandrasekaran',con:'University of Wisconsin-Madison'},
    // {name:'Xiaowei Huang',con:'Liverpool University'},
    // {name:'Xiao Yang',con:'Tsinghua University'},
    // {name:'Yanjun Qi',con:'University of Virginia'},
    // {name:'Yigitcan Kaya',con:'University of Maryland'},
    // {name:'Yinpeng Dong',con:'Tsinghua University'},
    // {name:'Yizheng Chen',con:'Georgia Tech'},
    // {name:'Zhenxing Niu',con:'Alibaba Group'},
    // {name:'Zhijie Deng',con:'Tsinghua University'},
    // {name:'Sravanti Addepalli',con:'Indian Institute of Science'},
    // {name:'Gaurang Sriramanan',con:'Indian Institute of Science'},
    {name:'Adam Kortylewski',con:'Johns Hopkins University'},
    // {name:'Ali Shahin Shamsabadi',con:'Queen Mary University of London, UK'},
    {name:'Aniruddha Saha',con:'University of Maryland Baltimore County'},
    {name:'Anshuman Suri',con:'University of Virginia'},
    {name:'Chang Xiao',con:'Columbia University'},
    {name:'Gaurang Sriramanan',con:	'Indian Institute of Science'},
    {name:'Hongyang Zhang',con:'TTIC'},
    {name:'Jamie Hayes',con:	'UCL'},
    {name:'Jiachen Sun',con:	'University of Michigan'},
    {name:'Lifeng Huang',con:	'SunYat-sen university'},
    {name:'Maksym Andriushchenko',con:	'EPFL'},
    {name:'Maura Pintor',con:	'University of Cagliari'},
    {name:'Muhammad Awais',con:	'Kyung-Hee University'},
    {name:'Nataniel Ruiz',con:	'Boston University'},
    {name:'Rajkumar Theagarajan',con:	'University of California, Riverside'},
    {name:'Sravanti Addepalli',con:	'Indian Institute of Science'},
    {name:'Wenxiao Wang',con:	'Tsinghua University'},
    {name:'Won Park',con:	'University of Michigan'},
    {name:'Xingjun Ma',con:	'Deakin University'},
    {name:'Xinwei Zhao',con:	'Drexel University'},
    {name:'Yash Sharma',con:	'University Tuebingen'},
    {name:'Yulong Cao',con:	'University of Michigan, Ann Arbor'},
    {name:'Yuzhe Yang',con:	'MIT'    },
    {name:"Tong Wu", con:"Washington University in St. Louis"},
    {name:"Zhao Li", con:"Alibaba Group"},
]
export default function Program() {
    return <div className="page-program">
            <div className="program-title">Program Committee</div>
            <Row className="list-ul">
                {arrs.map((item, index) => (<Col xl={4} lg={6} sm={12} span={12} key={index} className="list-li"> 
                    <div className="list-two">
                        <span>{item.name}</span>
                        <div>{item.con}</div>
                    </div>
                </Col>))}
            </Row>
        </div>
}
